import name from './name'
import { ACCOUNT_INFO_STATUS } from './slice'

const selectSliceData = state => state[name]
const selectAccountInfo = state => selectSliceData(state).accountInfo
const selectAccountInfoStatus = state => selectSliceData(state).accountInfoStatus
const selectAccountInfoErrorDetail = state => selectSliceData(state).accountInfoError
const selectAccountInfoAttempts = state => selectSliceData(state).accountInfoAttempts

// The store carries a status; most consumers ask a yes/no question of it.
const selectHasAccountInfo = state => Object.keys(selectAccountInfo(state)).length > 0
const selectAccountInfoIdle = state => selectAccountInfoStatus(state) === ACCOUNT_INFO_STATUS.idle
const selectAccountInfoRequested = state => selectAccountInfoStatus(state) === ACCOUNT_INFO_STATUS.loading
const selectAccountInfoError = state => selectAccountInfoStatus(state) === ACCOUNT_INFO_STATUS.error
// The request has come back, one way or the other.
const selectAccountInfoSettled = state => {
  const status = selectAccountInfoStatus(state)
  return status === ACCOUNT_INFO_STATUS.ready || status === ACCOUNT_INFO_STATUS.error
}
// "Loaded" means there is something authoritative to render: a response, or
// the data an earlier response brought while a later request fails or is
// still out. A failure with nothing behind it is not loaded — the trial
// banner, Gleap and the student-plan check fail closed instead of reading an
// empty account as the truth.
const selectAccountInfoLoaded = state =>
  selectAccountInfoStatus(state) === ACCOUNT_INFO_STATUS.ready || selectHasAccountInfo(state)

const setSubscriptionChangePending = state => selectSliceData(state).setSubscriptionChangePending
const selectSubscriptionChangePending = state => selectSliceData(state).subscriptionChangePending
const setSubscriptionChangeReceived = state => selectSliceData(state).setSubscriptionChangeReceived
const selectSubscriptionChangeReceived = state => selectSliceData(state).subscriptionChangeReceived

export {
  selectAccountInfo,
  selectAccountInfoStatus,
  selectAccountInfoErrorDetail,
  selectAccountInfoAttempts,
  selectHasAccountInfo,
  selectAccountInfoIdle,
  selectAccountInfoRequested,
  selectAccountInfoError,
  selectAccountInfoSettled,
  selectAccountInfoLoaded,
  setSubscriptionChangePending,
  selectSubscriptionChangePending,
  setSubscriptionChangeReceived,
  selectSubscriptionChangeReceived
}
